import React, { useState } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import { graphql, useStaticQuery } from 'gatsby'

import Hemiciclo from '../Hemiciclo'
import Wrapper from '@/components/Feature/Elegidos/Wrapper'
import Alternativas from '@/components/Feature/Elegidos/Alternativas'
import groupBy from '@/util/groupBy'
import colorCalc from '@/util/colorCalc'
import Sharer from '@/components/UI/Sharer'

const Card = ({
  title,
  description,
  elegidos,
  grouper,
  path,
  grouperIndex = 0,
}) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          urlwoslash
          hashtags
          twitterHandle
          siteName
        }
      }
    }
  `)

  const { diputados, senadores, senadoresEnEjercicio } = elegidos
  const [tabIndex, setTabIndex] = useState(0)
  const todosLosSenadores = [...senadoresEnEjercicio, ...senadores]

  const sharerstring = `Revisa las características de los diputados y senadores del congreso electo 2021 - ${site.siteMetadata.siteName}`

  const sharerpath = `${site.siteMetadata.urlwoslash}${path}`

  return (
    <div className="px-2 text-center card">
      <div className="container max-w-4xl pt-16 mx-auto card-body">
        <h1 className="leading-tight card-title">{title}</h1>
        <div className="text-left card-text">{description}</div>
        <Sharer url={sharerpath} title={sharerstring} />
      </div>
      <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
        <TabList>
          <Tab>Diputados</Tab>
          <Tab>Senadores (todos)</Tab>
          {/* <Tab>Senadores Electos</Tab>
          <Tab>Senadores En Ejercicio</Tab> */}
        </TabList>
        <TabPanel>
          <CardContent
            elegidos={diputados}
            grouper={grouper}
            grouperIndex={grouperIndex}
          />
        </TabPanel>
        <TabPanel>
          <CardContent
            elegidos={todosLosSenadores}
            grouper={grouper}
            grouperIndex={grouperIndex}
          />
        </TabPanel>
        {/* <TabPanel>
          <CardContent
            elegidos={senadores}
            grouper={grouper}
            grouperIndex={grouperIndex}
          />
        </TabPanel>
        <TabPanel>
          <CardContent
            elegidos={senadoresEnEjercicio}
            grouper={grouper}
            grouperIndex={grouperIndex}
          />
        </TabPanel> */}
      </Tabs>
    </div>
  )
}

const CardContent = ({ elegidos, grouper, grouperIndex }) => {
  const colors = [
    '#e6f598',
    '#abdda4',
    '#66c2a5',
    '#3288bd',
    '#5e4fa2',
    '#9e0142',
    '#d53e4f',
    '#f46d43',
    '#fdae61',
    '#fee08b',
  ]

  const byGrouper = groupBy(elegidos, grouper)

  const byGrouperArray = Object.keys(byGrouper).map((answer, index) => {
    return {
      name: answer === 'undefined' ? 'No respondió' : answer,
      color:
        answer === 'undefined'
          ? 'rgb(204, 204, 204)'
          : colorCalc(index, grouperIndex, colors),
      seats: byGrouper[answer],
    }
  })

  return (
    <Wrapper>
      <div className="cardcontent">
        <div>
          <Hemiciclo width={500} height={250} data={byGrouperArray} />
        </div>
        <div>
          <Alternativas
            data={byGrouperArray}
            total={elegidos.length}
            simple={true}
          />
        </div>
      </div>
    </Wrapper>
  )
}

export default Card
